<template>
  <tm-button
    :text-link="textLink"
    :color="color"
    :size="size"
    class="tm-watch-tutorial"
    :class="{
      [`tm-watch-tutorial_${size}`]: !!size,
      'tm-watch-tutorial_inverted': invertedColors,
    }"
    @click="clickHandler"
  >
    <tm-icon
      :name="outlinedIcon ? 'tmi-play-outline' : 'tmi-play'"
      small
      :left="true"
      class="tm-watch-tutorial__icon"
    />
    <span class="tm-watch-tutorial__text">
      {{ $t('common.watchTutorial') }}
    </span>
    <tm-video-modal-wistia
      ref="tmVideoModalWistiaElement"
      :video-id="videoId"
    />
  </tm-button>
</template>

<script setup lang="ts">
import TmVideoModalWistia from '@/components/shared/TmVideoModalWistia.vue'
import TmButton from '@/components/shared/TmButton.vue'
import TmIcon from '@/components/shared/TmIcon.vue'
import type { ButtonColor, ButtonSize } from '@/components/shared/types'
import { useTemplateRef } from '@/composition/vue/compositionApi'
import TmLogicError from '@/core/error/tmLogicError'

const {
  videoId,
  textLink = true,
  size,
  color,
  invertedColors = false,
  outlinedIcon = false,
} = defineProps<{
  videoId: string
  textLink?: boolean
  size?: ButtonSize
  color?: ButtonColor
  invertedColors?: boolean
  outlinedIcon?: boolean
}>()

const tmVideoModalWistiaElement = useTemplateRef('tmVideoModalWistiaElement')

const clickHandler = async () => {
  if (!tmVideoModalWistiaElement.value) {
    throw new TmLogicError('tmVideoModalWistiaElement.value is null')
  }
  const videoInstance = await tmVideoModalWistiaElement.value.getVideoInstance()
  if (!videoInstance.popover) {
    throw new TmLogicError('videoInstance.popover is null')
  }
  videoInstance.popover.show()
  videoInstance.play()
}
</script>

<style lang="scss" scoped>
.tm-watch-tutorial {
  position: relative;

  &__text {
    color: $gray8;
  }

  &:hover &__text,
  &:hover &__icon {
    color: $primary !important;
  }

  &__icon {
    color: $gray8;
  }

  &_inverted &__text,
  &_inverted &__icon {
    color: $primary;
  }

  &_inverted:hover &__text,
  &_inverted:hover &__icon {
    color: $gray8 !important;
  }
}
</style>
